import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2bbe2bdd&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=2bbe2bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe2bdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbe2bdd')) {
      api.createRecord('2bbe2bdd', component.options)
    } else {
      api.reload('2bbe2bdd', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2bbe2bdd&scoped=true&", function () {
      api.rerender('2bbe2bdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sp4zTBcYbPV3/JS/comp/Voucher.vue"
export default component.exports